import { useState, useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { AdminSidebar } from './AdminSidebar';
import { AdminHeader } from './AdminHeader';
import { OnboardingTour } from '@/features/onboarding';
import { useGetMeQuery } from '@/features/admin/api/adminApi';
import '@/styles/global.css';

export function AdminLayout() {
  const location = useLocation();

  // Single Sign-On (SSO) from Extension
  const searchParams = new URLSearchParams(location.search);
  const extToken = searchParams.get('ext_token');
  const extUser = searchParams.get('ext_user');

  if (extToken && extUser) {
    localStorage.setItem('admin_token', extToken);
    localStorage.setItem('admin_user', decodeURIComponent(extUser));
    // Clean URL
    window.history.replaceState({}, document.title, location.pathname);
  }

  const token = localStorage.getItem('admin_token');
  const adminUserRaw = localStorage.getItem('admin_user');
  
  const { data: meData } = useGetMeQuery(undefined, { skip: !token });
  const adminUser = meData?.data || (adminUserRaw ? JSON.parse(adminUserRaw) : null);

  useEffect(() => {
    if (meData?.data) {
      localStorage.setItem('admin_user', JSON.stringify(meData.data));
    }
  }, [meData]);

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  // Theme is permanently dark mode
  const theme = 'dark';

  // Sync theme to document.body to prevent background color bleeding
  useEffect(() => {
    document.body.classList.remove('admin-theme-light');
    document.body.classList.add('admin-theme-dark');
    
    const bgColor = '#010204';
    document.body.style.backgroundColor = bgColor;
    document.documentElement.style.backgroundColor = bgColor;

    return () => {
      document.body.style.backgroundColor = '';
      document.documentElement.style.backgroundColor = '';
    };
  }, []);



  return (
    <div className={`admin-dashboard-container ${theme === 'dark' ? 'admin-theme-dark' : 'admin-theme-light'}`}>
      <OnboardingTour />
      <AdminSidebar
        adminUser={adminUser}
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
        sidebarCollapsed={sidebarCollapsed}
        setSidebarCollapsed={setSidebarCollapsed}
      />

      <div className="admin-main-pane flex-1 w-full flex flex-col overflow-hidden">
        <AdminHeader
          adminUser={adminUser}
          setSidebarOpen={setSidebarOpen}
        />
        <main className="admin-main-body">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
